<template>
  <div class="jdl-aside-item" @click.stop>
    <!--如果只有一个子菜单，就展示该菜单项即可-->
    <template v-if="item && hasOneShowingChild(item.children, item)">
      <div>
        <!-- 此处要用多语言，需要根据多语言进行判断 -->
        <el-menu-item
          :class="{
            'submenu-title-noDropdown': !isNest,
            'hide-menu': !showSidebar,
            'first-level': level === 1 && showSidebar,
            'first-level-hide': level === 1 && !showSidebar,
            'second-level': level === 2 && showSidebar
          }"
          :index="onlyOneChild.url || onlyOneChild.code"
        >
          <item
            :item="onlyOneChild"
            :icon="onlyOneChild.iconCode ? onlyOneChild.iconCode.replace('-', '') : ''"
            :title="onlyOneChild.code"
            :level="level"
            :search-key="searchKey"
          />
        </el-menu-item>
      </div>
    </template>
    <!--如果有多个子菜单，先展示父菜单-->
    <el-submenu
      v-else-if="item && ((searchKey && $t(item.code.replace('-', '')).indexOf(searchKey) > -1) || !searchKey)"
      :index="item.code"
      popper-append-to-body
      class="el-menu-item-group-tms"
      :class="{
        'first-level': level === 1 && showSidebar,
        'second-level-sub': level === 2 && showSidebar
      }"
    >
      <!--展示父菜单，这里的slot=title是lui里定义的具名slot-->
      <template slot="title">
        <item
          :item="item"
          :level="level"
          has-child
          class="in-menu-father"
          :icon="item.iconCode ? item.iconCode.replace('-', '') : ''"
          :title="item.code"
          :search-key="searchKey"
          :common="common"
        />
      </template>
      <!--如果有子菜单，则递归展示sidebar-item-->
      <sidebar-item
        v-for="child in item.children"
        :key="child.url"
        :is-nest="true"
        :item="child"
        :level="level + 1"
        :base-path="resolvePath(child.url)"
        :search-key="searchKey"
        class="nest-menu"
      />
    </el-submenu>
  </div>
</template>

<script>
import path from 'path'
import { isExternal } from '@/utils/validate'
import Item from './Item.vue'
import { SappModule } from '@/store/modules/app'
// import ilSubmenu from '../../menu/src/submenu.vue'
// import ilMenuItem from '../../menu/src/menu-item.vue'

// import AppLink from './Link.vue'

export default {
  name: 'SidebarItem',
  components: { Item },
  props: {
    // route objectcommon
    item: {
      type: Object,
      required: true
    },
    common: {
      type: Boolean,
      default: false
    },
    level: {
      type: Number,
      default: 1
    },
    isNest: {
      type: Boolean,
      default: false
    },
    basePath: {
      type: String,
      default: ''
    },
    searchKey: {
      type: String,
      default: ''
    }
  },
  data() {
    // To fix https://github.com/PanJiaChen/vue-admin-template/issues/237
    // TODO: refactor with render function
    this.onlyOneChild = null
    return {
      toolTipDisabled: false
    }
  },
  computed: {
    showSidebar() {
      return SappModule.sidebar.opened
    },
    isShowToolTip() {
      return this.showToolTip ? this.toolTipDisabled : true
    },
    butsPermission() {
      return SappModule.butsPermission
    }
  },
  inject: ['showToolTip'],
  methods: {
    hasOneShowingChild(children = [], parent) {
      if (parent.code === 'PL-ServiceSupplier') {
        console.log('PL-ServiceSupplier', children, parent)
      }
      if (!children || !children.length) {
        this.onlyOneChild = parent
        return true
      }
      const showingChildren = children.filter((item) => {
        if (this.butsPermission.includes(item.code) || (item && item.hidden)) {
          return false
        }
        // Temp set(will be used if only has one showing child)
        this.onlyOneChild = item
        return true
      })
      // When there is only one child router, the child router is displayed by default
      if (showingChildren && showingChildren.length === 0) {
        this.onlyOneChild = parent
        return true
      }
      // if(showingChildren && showingChildren[0] && (!showingChildren[0].children  || !showingChildren[0].children.length)) {
      //   return true
      // }

      // Show parent if there are no child router to display
      if (showingChildren && showingChildren.length === 0) {
        this.onlyOneChild = { ...parent, noShowingChildren: true }
        return true
      }

      return false
    },
    resolvePath(routePath) {
      if (isExternal(routePath)) {
        return routePath
      }
      if (isExternal(this.basePath)) {
        return this.basePath
      }
      // console.log('this.basePath, routePath', this.basePath, routePath)
      return routePath // path.resolve(this.basePath, routePath)
    }
  }
}
</script>
<style lang="scss">
.first-level-hide{
  background-color: unset !important;
}
.second-level{
  padding-left: 40px !important;
}
.second-level-sub{
  .el-submenu__title{
    padding-left: 32px !important;
  }
}
.hideSidebar{
  .el-submenu__title{
    &:hover{
      background-color: unset !important;
    }
  }
}
</style>
<style lang="scss" scoped>

::v-deep .el-menu-item {
  height: auto;
  &:hover {
    .action-icon {
      opacity: 1;
    }
  }
}
</style>
